import { Component, Injector, OnInit, ElementRef, ViewChild } from '@angular/core';
import { inject } from '@angular/core';
import { Database, ref, set, child, get, onValue, update } from "@angular/fire/database";
import { BaseComponent } from 'src/app/shared/baseComponent';
import { getAuth, signInWithPopup, GoogleAuthProvider } from "@angular/fire/auth";

const VALID_DOMAINS = ['cellpodium.com', 's5-tech.com']

@Component({
  selector: 'app-avatars',
  templateUrl: './avatars.component.html',
  styleUrls: ['./avatars.component.css']
})
export class AvatarsComponent extends BaseComponent implements OnInit {
  avatars: any = []
  avatar: any = {name: "", scale: 1, seqNo: 10}


  database = inject(Database);
  isAuthenticatedWithFirebase = false
  private googleAuthProvider = new GoogleAuthProvider();

  constructor(injector: Injector) {
    super(injector)
  }
  async ngOnInit(): Promise<void> {
    this.isAuthenticatedWithFirebase = getAuth().currentUser != null
    if (this.isAuthenticatedWithFirebase) {
      await this.onSuccessfullLogin()
    }
  }

  async signInWithGoogle() {
    const auth = getAuth();
    try {
      const credential = await signInWithPopup(auth, this.googleAuthProvider)
      if (credential.user.email == null) {
        await auth.signOut();
        return
      }
      const domain = credential.user?.email.split('@')[1]?.toLowerCase();
      if (!VALID_DOMAINS.includes(domain)) {
        await auth.signOut();
        return
      }
      this.isAuthenticatedWithFirebase = true
      await this.onSuccessfullLogin()
    } catch (error: any) {
      alert((error as Error).message)
    }
  }
  private async onSuccessfullLogin() {
    await this.getData()
  }
  async getData() {
    this.loader.show()
    const avatarsRef = ref(this.database, 'avatars');
    const snapshot = await get(avatarsRef);
    if (snapshot.exists()) {
      this.avatars = snapshot.val();
    }
    this.loader.hide()
  }
  async deleteAvatar(avatar: any) {
    this.toast.success("Deleting avatar " + avatar)
    delete this.avatars[avatar]
    await set(ref(this.database, 'avatars'), this.avatars);
    await this.getData()
  }
  selectAvatar(item: any){
    this.avatar = this.avatars[item.key]
    this.avatar.name = item.key
  }
  async addAvatar() {
    this.avatars[this.avatar.name] = {scale: this.avatar.scale, seqNo: this.avatar.seqNo}
    await set(ref(this.database, 'avatars'), this.avatars);
    await this.getData()
  }

}

